import { useContext } from 'react';

import { OAuthContext } from '@/contexts';

const useOAuth = () => {
  const ctx = useContext(OAuthContext);

  if (!ctx) {
    throw new Error('useOAuth must be used within <OAuthProvider>');
  }

  return ctx;
};

export default useOAuth;
